import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbCollapseModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'

import { CostDisplayComponent } from './components/costDisplay.component'
import { CloudAccountCostsComponent } from './components/cloudAccountCosts.component'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    NgbCollapseModule,
    NgbTooltipModule,
    LocaleModule.forChild(),
  ],
  declarations: [
    CloudAccountCostsComponent,
    CostDisplayComponent,
  ],
  exports: [
    CloudAccountCostsComponent,
    CostDisplayComponent,
  ],
})
export class StatusModule { }
